<template>
  <div class="wash-container">
    <div class="wash-top">
      <div v-for="(item, i) in vehicles" :key="i" class="wash-top-left">
        <el-carousel ref="wash" :autoplay="false" height="350px">
          <el-carousel-item
            v-for="item_ in imgVehiclesListInfoArr[i]"
            :key="item_"
          >
            <img style="width: 100%; height: 100%" :src="item_.imgUrl" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div v-for="(item, i) in warns" :key="i" class="wash-top-right">
        <el-carousel ref="warn" :autoplay="false" height="350px">
          <el-carousel-item
            v-for="item_ in imgWarnsListInfoArr[i]"
            :key="item_"
          >
            <img
              style="width: 100%; height: 300px"
              :src="item_.imgUrl"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="wash-bottom">
      <div v-for="(item, i) in vehicles" :key="i" class="wash-bottom-left">
        <div class="wash-bottom-head">
          <img class="title-img" src="./img/icon_gear_default.png" />
          <span class="equipType">洗车机-</span>
          <span> {{ item.deviceName }}</span>
        </div>
        <div class="wash-bottom-chart" :id="'vehiclesChart-' + i"></div>
      </div>
      <div v-for="(item, i) in warns" :key="i" class="wash-bottom-right">
        <div class="wash-bottom-head">
          <img class="title-img" src="./img/icon_gear_default.png" />
          <span class="equipType">违规抓拍</span>
        </div>
        <div class="wash-bottom-chart" :id="'warnsChart-' + i"></div>
      </div>
    </div>
  </div>
</template>

<script>
function getVehicleOpt(pmData, that, n) {
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "rgba(47,128,237, 0.05)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(86,204,242, 0.25)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(86,204,242, 0.45)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 0, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(4, 0, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 400,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params[0]) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${"洗车水压"}: ${
              params[0].value
            } kpa</span></br>`;
          } catch {}
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;洗车水压：${params[i].value[2].vdmTdc} kpa</span></br>&nbsp;&nbsp;&nbsp;&nbsp;车牌号：${params[i].value[2].car_name} </span></br>&nbsp;&nbsp;&nbsp;&nbsp;洗车时长：${params[i].value[2].runTimeValue} </span></br>`;
              }
            } catch {}
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      left: "40%",
      top: "8%",
      data: [{ name: "洗车水压 ", icon: "circle" }],
      formatter: function (name) {
        return name;
      },
      itemWidth: 20,
      itemHeight: 20,
      textStyle: {
        fontSize: 14,
        color: "rgba(255,255,255,0.6)",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "15%",
      left: "5%",
      right: "6%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "grey",
            width: 0.1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#b1b6b7",
            fontSize: 15,
            margin: 15,
          },
          formatter(param) {
            let str = "";
            const strArr = param.split("-");
            const month = strArr[1];
            const date = strArr[2].split(" ")[0];
            const hour = strArr[2].split(" ")[1].split(":")[0];
            const minute = strArr[2].split(" ")[1].split(":")[1];
            str = `${month}-${date} ${hour}:${minute}`;
            return str;
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: [
      {
        name: "单位：kPa",
        nameTextStyle: {
          fontSize: 14,
          color: "#A6CAFF",
          padding: [0, 0, 0, 20],
        },
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "小时监测",
        type: "line",
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          normal: {
            width: 3,
            color: "#00FFFF",
          },
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.RadialGradient(
              0.5,
              0.5,
              0.5,
              [
                {
                  offset: 0,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 255, 255, 0.5)",
                },
              ],
              false
            ),
          },
        },
        data: y1Data,
      },
      {
        name: "洗车水压",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
    ],
  };
}
function getWarnOpt(pmData, that, n) {
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "rgba(47,128,237, 0.05)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(86,204,242, 0.25)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(86,204,242, 0.45)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 0, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(4, 0, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 400,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params[0]) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${"违规地点"}: ${
              params[0].value[2].position
            } </span></br><span>${"违规车辆"}: ${
              params[0].value[2].deviceNo
            } </span></br><span>${"违规描述"}: ${
              params[0].value[2].describe
            } </span></br><span>${"处理结果"}: ${
              params[0].value[2].result
            } </span></br>`;
          } catch {}
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;洗车水压：${params[i].value[2].vdmTdc} kpa</span></br>&nbsp;&nbsp;&nbsp;&nbsp;车牌号：${params[i].value[2].car_name} </span></br>&nbsp;&nbsp;&nbsp;&nbsp;洗车时长：${params[i].value[2].runTimeValue} </span></br>`;
              }
            } catch {}
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      left: "40%",
      top: "8%",
      data: [{ name: "洗车水压 ", icon: "circle" }],
      formatter: function (name) {
        return name;
      },
      itemWidth: 20,
      itemHeight: 20,
      textStyle: {
        fontSize: 14,
        color: "rgba(255,255,255,0.6)",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "15%",
      left: "5%",
      right: "6%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "grey",
            width: 0.1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#b1b6b7",
            fontSize: 15,
            margin: 15,
          },
          formatter(param) {
            let str = "";
            const strArr = param.split("-");
            const month = strArr[1];
            const date = strArr[2].split(" ")[0];
            const hour = strArr[2].split(" ")[1].split(":")[0];
            const minute = strArr[2].split(" ")[1].split(":")[1];
            str = `${month}-${date} ${hour}:${minute}`;
            return str;
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: [
      {
        name: "单位：次",
        nameTextStyle: {
          fontSize: 14,
          color: "#A6CAFF",
          padding: [0, 0, 0, 20],
        },
        max: 2,
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
          },
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "洗车水压",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
    ],
  };
}

import { dateFormat, unwarp } from "@/utils/tools.js";
export default {
  name: "WashBar",
  props: {
    washDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    washDetail: {
      handler(n) {
        this.getWashCarInfo();
        this.getWashWarnInfo();
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      vehicles: [],
      warns: [],
      vehiclesChart: [],
      imgVehiclesListInfoArr: [],
      warnsChart: [],
      imgWarnsListInfoArr: [],
    };
  },
  methods: {
    // 获取洗车机信息
    async getWashCarInfo() {
      console.log(this.washDetail.deviceNo);
      let url = CONFIG.requestName + this.$apiOpt.getCarWashProcessInfo;
      const param = {
        customerId: this.$store.state.customerId,
        // customerId: 38,
        dtuNum: this.washDetail.deviceNo,
        // dtuNum: "YG_ZL_XCT_13",
        startTime: this.$moment().format("YYYY-MM-DD 00:00:00"),
        endTime: this.$moment().format("YYYY-MM-DD 23:59:59"),
        pageNo: 1,
        pageSize: 1000,
      };
      try {
        let res = await this.$apiUtils.get(url, param);
        let records =
          res["page"] && res["page"]["records"] ? res["page"]["records"] : [];
        records = records.sort(
          (a, b) =>
            new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
        );
        let vdmsVehicles = [];
        let vdmsVehicleObj = {
          signalDetailList: [],
          vdmImgList: [],
          deviceName: "",
        };
        records.forEach((item) => {
          vdmsVehicleObj.vdmImgList.push({
            collectionTime: item.startTime,
            createTime: item.startTime,
            runTime: item.runTimeValue,
            deviceNo: item.car_name,
            id: item.id,
            imgUrl: item.pic_url,
            isAlarm: false,
            signalNo: item.device_no,
            value: item.pressure.replace("kPa", ""),
          });

          vdmsVehicleObj.deviceName = item.device_no;
        });
        for (let i = 0; i < 24; i++) {
          let hour = i < 10 ? "0" + i : i;
          vdmsVehicleObj.signalDetailList.push({
            dateTime: this.$moment().format("YYYY-MM-DD " + hour + ":00:00"),
            value: 0,
          });
        }
        vdmsVehicles.push(vdmsVehicleObj);
        this.vehicles = vdmsVehicles;
        this.$nextTick(() => {
          this.vehicles.forEach((item, i) => {
            this.vehicleHistoricalOperation(item, i);
          });
        });
      } catch (err) {
        console.error(err);
      }
    },
    // 获取违规信息
    async getWashWarnInfo() {
      let url = CONFIG.requestName + this.$apiOpt.violationNew;
      let param = {
        deviceNo: this.washDetail.deviceNo,
        // deviceNo: "YG_ZL_XCT_13",
        triggerType: "",
        Postion: "",
        startTime: this.$moment().format("YYYY-MM-DD 00:00:00"),
        endTime: this.$moment().format("YYYY-MM-DD 23:59:59"),
        customerId: this.$store.state.customerId,
        // customerId: 38,
        pageNo: 1,
        pageSize: 1000,
      };
      try {
        let res_ = await this.$apiUtils.get(url, param);
        let warnRecords = res_["records"] ? res_["records"] : [];
        warnRecords = warnRecords.sort(
          (a, b) =>
            new Date(a.createTime).getTime() - new Date(b.createTime).getTime()
        );
        let vdmsWarn = [];
        let vdmsWarnObj = {
          signalDetailList: [],
          vdmImgList: [],
          deviceName: "",
        };
        warnRecords.forEach((item) => {
          vdmsWarnObj.vdmImgList.push({
            collectionTime: item.createTime,
            createTime: item.createTime,
            runTime: item.runTimeValue,
            deviceName: item.deviceName,
            deviceNo: item.deviceNo,
            position: item.position,
            id: item.id,
            imgUrl: item.fileName,
            isAlarm: true,
            result: item.result,
            describe: item.describe,
            value: 1,
          });

          vdmsWarnObj.deviceName = item.deviceName;
        });
        for (let i = 0; i < 24; i++) {
          let hour = i < 10 ? "0" + i : i;
          vdmsWarnObj.signalDetailList.push({
            dateTime: this.$moment().format("YYYY-MM-DD " + hour + ":00:00"),
            value: undefined,
          });
        }
        vdmsWarn.push(vdmsWarnObj);
        this.warns = vdmsWarn;
        this.$nextTick(() => {
          this.warns.forEach((item, i) => {
            this.warnHistoricalOperation(item, i);
          });
        });
      } catch (err) {
        console.error(err);
      }
    },
    vehicleHistoricalOperation(vehicleList, n) {
      if (this.vehiclesChart[n]) {
        this.vehiclesChart[n] = null;
      }
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let tmpImgList = vehicleList.vdmImgList.sort(
        (a, b) =>
          new Date(a.collectionTime).getTime() -
          new Date(b.collectionTime).getTime()
      );
      this.imgVehiclesListInfoArr[n] = tmpImgList;
      let signalDetailList = vehicleList.signalDetailList.sort(
        (a, b) =>
          new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
      );
      signalDetailList.forEach((_) => {
        pmData.xData.push(_.dateTime);
        pmData.y1Data.push(_.value);
      });
      tmpImgList.forEach((m, n) => {
        m.tdc = m.value;
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.tdc);
              }
            }
          }
        }
      });
      tmpImgList.forEach((item, i) => {
        for (var x = 0; x < pmData.xData.length; x++) {
          if (item.collectionTime == pmData.xData[x]) {
            item.index = x;
            break;
          }
        }
      });
      tmpImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.tdc || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
            car_name: v.deviceNo,
            runTimeValue: v.runTime,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        if (this.vehiclesChart[n]) {
          this.vehiclesChart[n] = null;
        }
        this.vehiclesChart[n] = echarts.init(
          document.getElementById("vehiclesChart-" + n)
        );
        let vehiclesOptions = getVehicleOpt(pmData, this, n);
        unwarp(this.vehiclesChart[n]).setOption(vehiclesOptions);
        this.vehiclesChart[n].on("mouseover", (param) => {
          const { data } = param;
          let tmp = data[0];
          let index = this.imgVehiclesListInfoArr[n].findIndex(
            (item) => item.collectionTime === tmp
          );
          if (index !== -1) this.$refs.wash[n].setActiveItem(index);
        });
      });
    },
    warnHistoricalOperation(warnList, n) {
      if (this.warnsChart[n]) this.warnsChart[n] = null;
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let tmpImgList = warnList.vdmImgList.sort(
        (a, b) =>
          new Date(a.collectionTime).getTime() -
          new Date(b.collectionTime).getTime()
      );
      this.imgWarnsListInfoArr[n] = tmpImgList;
      let signalDetailList = warnList.signalDetailList.sort(
        (a, b) =>
          new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
      );
      signalDetailList.forEach((_) => {
        pmData.xData.push(_.dateTime);
        pmData.y1Data.push(_.value);
      });
      tmpImgList.forEach((m, n) => {
        m.tdc = m.value;
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.tdc);
              }
            }
          }
        }
      });
      tmpImgList.forEach((item, i) => {
        for (var x = 0; x < pmData.xData.length; x++) {
          if (item.collectionTime == pmData.xData[x]) {
            item.index = x;
            break;
          }
        }
      });
      tmpImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.tdc || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
            position: v.position,
            deviceNo: v.deviceNo,
            describe: v.describe,
            result: v.result,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        if (this.warnsChart[n]) {
          this.warnsChart[n] = null;
        }
        this.warnsChart[n] = echarts.init(
          document.getElementById("warnsChart-" + n)
        );
        let warnsOptions = getWarnOpt(pmData, this, n);
        unwarp(this.warnsChart[n]).setOption(warnsOptions);
        this.warnsChart[n].on("mouseover", (param) => {
          const { data } = param;
          let tmp = data[0];
          let index = this.imgWarnsListInfoArr[n].findIndex(
            (item) => item.collectionTime === tmp
          );
          if (index !== -1) this.$refs.warn[n].setActiveItem(index);
        });
      });
    },
  },
  mounted() {
    // this.getWashCarInfo();
    // this.getWashWarnInfo();
  },
  unmounted() {
    Object.assign(this.$data, this.$options.data());
  },
};
</script>

<style lang="scss" scoped>
.wash {
  &-container {
    width: 100%;
    height: 100%;
    padding: 20px 15px 20px 150px;
  }
  &-top {
    height: 350px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    &-left,
    &-right {
      width: 49%;
      background: #15244d;
      box-shadow: inset 0px 0px 8px 0px #7ba7ff;
    }
  }
  &-bottom {
    height: calc(100% - 400px);
    display: flex;
    justify-content: space-between;
    &-left,
    &-right {
      width: 49%;
      height: 100%;
      background: #15244d;
      box-shadow: inset 0px 0px 8px 0px #7ba7ff;
    }
    &-head {
      height: 50px;
      line-height: 50px;
    }
    &-chart {
      height: calc(100% - 50px);
    }
  }
}
:deep(.el-carousel__indicators--horizontal) {
  display: none;
}
</style>